export default __webpack_public_path__ + "static/media/mt_portfolio-03.a9b737b0.png";